import { getAddressSuggestion } from './getAddressSuggestion';

export function serializeAddress(suggestions: Array<YMaps.ISuggestResult> = []) {
  return suggestions.slice(0, 4).map(getAddressSuggestion);
}
